module.exports = __webpack_public_path__ + "static/media/hunter-attack-button.8ce53739.png";